// extracted by mini-css-extract-plugin
module.exports = {"root":"MessageDefault_root__2sLtS","content":"MessageDefault_content__1FaHI","message":"MessageDefault_message__fSxi9","action":"MessageDefault_action__10Mel"};